import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { BaseQuestionGradingComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { MatchingGradingAnswers } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAnswerGroup = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));

var roundNumber = function roundNumber(number) {
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
};

var calculateTotalScore = function calculateTotalScore(answers) {
  var allNotGraded = answers.every(function (answer) {
    return !answer.hasGraded();
  });

  if (allNotGraded) {
    return null;
  }

  return answers.reduce(function (total, answer) {
    if (!answer.hasGraded()) {
      return total;
    }

    return roundNumber(total + answer.score);
  }, 0);
};

var areAllSubQuestionsGraded = function areAllSubQuestionsGraded(answers) {
  return answers.every(function (answer) {
    return answer.score !== SubmissionScore["default"].value;
  });
};

export var MatchingGradingComponent = function MatchingGradingComponent(_ref) {
  var _states$isShowingScor;

  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var matchingQuestion = question;
  var baseLabel = states.label,
      matchingGroupAnswer = states.answer,
      updatedAnswerId = states.updatedAnswerId,
      disabled = states.disabled,
      isPreviewMode = states.isPreviewMode,
      isSubmissionSubmitted = states.isSubmissionSubmitted,
      isShowingExplanation = states.isShowingExplanation;
  var label = {
    correctAnswer: baseLabel.correctAnswer,
    disabledScoreInputText: baseLabel.disabledScoreInputText,
    score: baseLabel.score,
    invalidScore: baseLabel.invalidScore,
    colorStatusCorrect: baseLabel.colorStatusCorrect,
    colorStatusIncorrect: baseLabel.colorStatusIncorrect,
    colorStatusCustomGrade: baseLabel.colorStatusCustomGrade,
    colorStatusSkipped: baseLabel.skipped
  };
  var submitGradeAnswer = actions.submitGradeAnswer;
  var totalScore = useMemo(function () {
    return calculateTotalScore((matchingGroupAnswer === null || matchingGroupAnswer === void 0 ? void 0 : matchingGroupAnswer.answers) || []);
  }, [matchingGroupAnswer === null || matchingGroupAnswer === void 0 ? void 0 : matchingGroupAnswer.answers]);
  var isAllSubQuestionAnswerGraded = useMemo(function () {
    return areAllSubQuestionsGraded((matchingGroupAnswer === null || matchingGroupAnswer === void 0 ? void 0 : matchingGroupAnswer.answers) || []);
  }, [matchingGroupAnswer === null || matchingGroupAnswer === void 0 ? void 0 : matchingGroupAnswer.answers]);
  var answerOptions = useMemo(function () {
    return (matchingQuestion.answers || []).map(function (a) {
      return {
        value: a.id.toString(),
        label: a.description
      };
    });
  }, [matchingQuestion.answers]);
  return /*#__PURE__*/_jsx(BaseQuestionGradingComponent, {
    states: _objectSpread(_objectSpread({}, states), {}, {
      value: totalScore,
      isEssayQuestion: true,
      isAllQuestionAnswersGraded: isAllSubQuestionAnswerGraded
    }),
    actions: actions,
    children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
      direction: "vertical",
      size: "middle",
      children: /*#__PURE__*/_jsx(MatchingGradingAnswers, {
        matchingQuestion: matchingQuestion,
        matchingGroupAnswer: matchingGroupAnswer,
        label: label,
        isSubmissionSubmitted: isSubmissionSubmitted,
        submitGradeAnswer: submitGradeAnswer,
        disabled: disabled,
        updatedAnswerId: updatedAnswerId,
        isPreviewMode: isPreviewMode,
        answerOptions: answerOptions,
        isShowingExplanation: isShowingExplanation,
        isShowingScoreInput: (_states$isShowingScor = states.isShowingScoreInput) !== null && _states$isShowingScor !== void 0 ? _states$isShowingScor : true
      })
    })
  });
};